import { Backbone, Marionette } from "global/globals"
import { decodeUtf8 } from "base/backbone/lib/utilities/helpers";

export var Pixlee = (function(Backbone, Marionette) {

    var App = new Marionette.Application();
    App.version = 'v4';

    // gon is accessible at this point
    App.isMobile = gon.isMobile || false;
    App.isTablet = gon.isTablet || false;
    App.isDesktop = !gon.isMobile && !gon.isTablet;

    var isLabelPresent = !!(gon.display_options.tosLabel_text && gon.display_options.tosLabel_text.trim());
    var isLinkPresent = !!(gon.display_options.tosLink_text && gon.display_options.tosLink_text.trim());

    App.hasTOS = isLabelPresent && isLinkPresent;


    function getParameterByName(name, url) {
        name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            results = regex.exec(url);
        return results == null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function cookieAsyncCall() {
        $.ajax({
            url: '/initializeCookie',
            type: 'POST',
            data: {
                distinct_user_hash: gon.distinct_user_hash
            },
            dataType: 'json',
            success: function(response) {
                gon.pixlee_votes = response.votes;
                App.execute('vote:loaded');

                var message = {
                    name: 'pixlee:vote:loaded',
                    type: 'relay',
                    source: 'widget',
                    destination: 'lightbox',
                    data: {
                        pixlee_votes: response.votes
                    }
                };

                window.top.postMessage(JSON.stringify(message), '*');
            }
        });
    }

    var widgetDetailsMessage = {
        name: 'pixlee:widget:size:fix',
        type: 'action',
        source: 'widget',
        destination: 'parent',
        data: {
            widgetType: gon.type,
            widgetId: gon.publication_id
        }
    };

    if (gon.action === 'show_widget') {
        window.parent.postMessage(JSON.stringify(widgetDetailsMessage), '*');
    }

    var experimentMessage = {
        name: 'pixlee:experiment:info',
        type: 'action',
        source: 'widget',
        destination: 'parent',
        data: {
            experimenting: gon.experimenting
        }
    };
    if (experimentMessage.data.experimenting) {
        experimentMessage.data.experiment_id = gon.experiment_id;
        experimentMessage.data.experiment_group = gon.experiment_group;
    }
    window.parent.postMessage(JSON.stringify(experimentMessage), '*');

    if (gon.experimenting && gon.experiment_group && gon.experiment_group === 'no_widget') {
        var hideWidgetMessage = {
            name: 'pixlee:hide:widget',
            type: 'action',
            source: 'widget',
            destination: 'parent',
            data: {}
        };
        window.parent.postMessage(JSON.stringify(hideWidgetMessage), '*');
    }

    //if it's a voting album, try a lot. if not, just try once
    var pollLimit = (gon.current_album && gon.current_album.campaign) ? 50 : 1;
    var currentPoll = 0;

    function initializeDUHAndCookie() {
        if (currentPoll < pollLimit) {
            currentPoll = currentPoll + 1;
            //if user hash isn't ready, try to get it. keep trying till it's defined
            setTimeout(function() {
                if (_.isFalsy(gon.distinct_user_hash)) {
                    if (typeof analytics !== 'undefined' && analytics.getAnonymousId) {
                        gon.distinct_user_hash = analytics.getAnonymousId();
                    }
                    initializeDUHAndCookie();
                } else {
                    cookieAsyncCall();
                }
            }, 100);
        } else {
            var msg = {
                name: 'pixlee:log:to:sentry',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    messageText: 'Failed to retrieve DUH',
                    messageExtraFields: {
                        tags: {
                            source: 'widgets',
                            analytics: typeof analytics !== 'undefined',
                            file: 'photos_app_v2.js'
                        }
                    }
                }
            };
            //window.parent.postMessage(JSON.stringify(msg), '*');
        }
    }

    function addWindowEventListener() {

        window.addEventListener('message', function(event) {
            var eventData;
            if (event.data) {
                try {
                    eventData = JSON.parse(event.data);
                } catch (error) {
                    // Some other way of sending data, ignore
                    return;
                }
            } else {
                return;
            }

            if (eventData.name && eventData.name === 'pixlee:css:generated') {
                $.ajax({
                    url: '/generatecss',
                    type: 'POST',
                    data: eventData.data,
                    dataType: 'json',
                    success: function(response) {
                        $('#proserveStylesheet').html(response.proserve_css);
                        $('#dynamicStylesheet').html(response.css);
                        App.execute('stylesheet:generated', response.css, response.params, response.display_options);
                        //Setting Standalone variables for Design Editor
                        App.displayOptions.set('standaloneOptions.bannerImage_showHide', eventData.data.displayOptions.standaloneOptions.bannerImage_showHide);
                        App.displayOptions.set('standaloneOptions.logoImage_showHide', eventData.data.displayOptions.standaloneOptions.logoImage_showHide);
                        App.displayOptions.set('standaloneOptions.logoImage_input', eventData.data.displayOptions.standaloneOptions.logoImage_input);
                        App.displayOptions.set('standaloneOptions.bannerImage_input', eventData.data.displayOptions.standaloneOptions.bannerImage_input);
                        App.displayOptions.set('standaloneOptions.logoImage_backgroundImage', eventData.data.displayOptions.standaloneOptions.logoImage_backgroundImage);
                        App.displayOptions.set('standaloneOptions.bannerImage_backgroundImage', eventData.data.displayOptions.standaloneOptions.bannerImage_backgroundImage);
                        // Set Header tile options from Design Editor
                        App.displayOptions.set('headerOptions.end_tile_upload_button_background_showHide', eventData.data.displayOptions.headerOptions.end_tile_upload_button_background_showHide);
                        // Set Review options from Design Editor
                        App.displayOptions.set('reviewOptions.lightboxReviews', eventData.data.displayOptions.reviewOptions.lightboxReviews);
                        App.displayOptions.set('reviewOptions.frequency', eventData.data.displayOptions.reviewOptions.frequency);
                        // Set Carousel options from Design Editor
                        App.displayOptions.set('carouselOptions.smoothSwiping', eventData.data.displayOptions.carouselOptions.smoothSwiping);
                        // Set Misc Options
                        App.displayOptions.set('pageSize', eventData.data.displayOptions.pageSize);
                    }
                });
            }
        }, false);
    }
    App.on('before:start', function(options) {
        App.isWidget = true;
        App.config = App.request('set:config:photos:app');
        App.currentUser = App.request('set:current:user', options.current_account);
        App.currentAlbum = App.request('set:current:album', options.current_album);
        App.displayOptions = new App.Entities.DisplayOptions(options.display_options);
        App.recipe = App.request('set:recipe', options.recipe);

        // combines base translations and customer's custom text that was set in the Design Editor
        $.extend(true, I18n.translations[I18n.locale], gon.custom_text);

        // alt text priority: album.description -> album.title -> default
        if (_.isFalsy(App.currentAlbum.get('description'))) {
            if (_.isFalsy(App.currentAlbum.get('title'))) {
                App.altText = "This is a photo gallery";
            } else {
                App.altText = "This is a photo gallery with the title of: " + decodeUtf8(App.currentAlbum.get('title'));
            }
        } else {
            App.altText = "This is a photo gallery with the title of: " + decodeUtf8(App.currentAlbum.get('description'));
        }

        if (gon.previewMode) {
            addWindowEventListener();
        } else {
            var receiveMessage = function(event) {
                var eventData;
                if (event.data) {
                    try {
                        eventData = JSON.parse(event.data);
                    } catch (error) {
                        // Some other way of sending data, ignore
                        return;
                    }
                } else {
                    return;
                }

                if (eventData && eventData.name && eventData.name === 'pixlee:hide:lightbox') {
                    // this causes the widget on the page to sometimes "jump" in focus when the lightbox closes.
                    // we don't want this to happen in some cases such as the PUMA in store widget display
                    if (App.displayOptions.get('disableFocusAfterCloseLightbox')) {
                        return;
                    }
                    if (_.isTruthy(window.lastElement)) {
                        window.lastElement.focus();
                    }
                }

                if (eventData && eventData.name && eventData.name === 'pixlee:close:uploader') {
                    // this causes the widget on the page to sometimes "jump" in focus when the lightbox closes.
                    // we don't want this to happen in some cases such as the PUMA in store widget display
                    if (App.displayOptions.get('disableFocusAfterCloseLightbox')) {
                        return;
                    }
                    if (_.isTruthy(window.lastElement)) {
                        window.lastElement.focus();
                    }
                }

                if (eventData && eventData.name && eventData.name === 'pixlee:social:login') {
                    App.execute('social:login', eventData.data);
                }
                if (eventData && eventData.name && eventData.name === 'pixlee:social:login:loaded') {
                    App.execute('social:login:loaded');
                }
                if (eventData && eventData.name && eventData.name === 'pixlee:widget:visible') {
                    //only listen to the event of this widget
                    if (eventData.data.src === window.location.href) {
                        setTimeout(function() {
                            App.execute('widget:visible');
                        }, 500);
                    }
                }
                if (eventData && eventData.function && eventData.function === 'kpiEvent') {
                    var ev;
                    if (eventData.data && eventData.data.event) {
                        ev = eventData.data.event;
                    }
                    App.execute('kpi:event', ev);
                }
                if (eventData.name && eventData.name === 'pixlee:fingerprint') {
                    gon.fingerprint = eventData.data;
                }
            };
            window.addEventListener('message', receiveMessage, false);
        }
        App.publication_id = options.widget_id;
    });
    initializeDUHAndCookie();
    App.reqres.setHandler('get:current:album', function() {
        return App.currentAlbum;
    });
    App.reqres.setHandler('get:display:options', function() {
        return App.displayOptions;
    });
    App.reqres.setHandler('get:recipe', function() {
        return App.recipe;
    });
    App.reqres.setHandler('get:photo:url', function(id) {
        return Routes.distillery_photo_path(id);
    });
    App.reqres.setHandler('get:location:url', function() {
        return Routes.distillery_analytics_location_path();
    });
    App.addRegions({
        widget: '#widget'
    });
    App.reqres.setHandler('default:region', function() {
        return App.widget;
    });

    App.commands.setHandler('register:instance', function(instance, id) {
        if (App.config.environment === 'development') {
            return App.register(instance, id);
        }
    });

    App.reqres.setHandler('concern', function(concern) {
        return App.Concerns[concern];
    });

    App.commands.setHandler('unregister:instance', function(instance, id) {
        if (App.config.environment === 'development') {
            return App.unregister(instance, id);
        }
    });

    App.commands.setHandlers({
        'show:uploader:loader': function() {
            $('#uploader_loader').show();
        },
        'hide:uploader:loader': function() {
            $('#uploader_loader').hide();
        },
        'nav:right': function(itemIndex, photosCollection) {
            var msg = {
                name: 'pixlee:widget:navigated',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {}
            };
            window.parent.postMessage(JSON.stringify(msg), '*');
            App.commands.execute('nav:right:event', itemIndex, photosCollection);
        }
    });

    return App;

})(Backbone, Marionette);
window.Pixlee = Pixlee;
